import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
  ViewEncapsulation,
} from "@angular/core";
import { MarcaService } from "../../../../../shared/services/marca.service";
import { VehiclesService } from "../../../../../shared/services/vehicles.service";

import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbAccordion, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NgSelectComponent } from "@ng-select/ng-select";
import { NgbdSortableHeader } from "../../../../../shared/directives/NgbdSortableHeader";

import { Utils } from "../../../../../shared/utils/Utils";

declare var require;
const Swal = require("sweetalert2");

@Component({
  selector: 'app-marcas-inactivas',
  templateUrl: './marcas-inactivas.component.html',
  styleUrls: ['./marcas-inactivas.component.scss']
})
export class MarcasInactivasComponent {
  @ViewChild("inputServicio") inputServicio!: ElementRef;
  @ViewChild("inputPlaca") inputPlaca!: ElementRef;
  @ViewChild("inputInterno") inputInterno!: ElementRef;
  @ViewChild("inputEmpresa") inputEmpresa!: NgSelectComponent;
  @ViewChild("inputClase") inputClase!: NgSelectComponent;
  @ViewChild("inputMarca") inputMarca!: NgSelectComponent;
  @ViewChild("inputModelo") inputModelo!: NgSelectComponent;
  @ViewChild("inputRelacion") inputRelacion!: NgSelectComponent;
  @ViewChild("inputPassword") inputPassword!: ElementRef;
  @ViewChild("accordion", { static: false }) accordion!: NgbAccordion;
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;


  pageSize1: number = 5; 
  page1: number = 1;
  totalItems: number;
  filteredTableItems: any[] = [];
  public searchText: string = ''; // Texto de búsqueda
  sortColumn: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';
  

 
  formData: any = {}; // Inicializar vacío para evitar errores
  empresas: any[];
  todasLasEmpresas: any;
  marcas: any;
  tipos: any;
  propietarios: any;
  formNuevo: FormGroup;
  validate: boolean = false;
  errores: any = {};
  relaciones: any;
  modelos: any; 
  editMode: boolean;  
  empresaselecionada: any;
  formClase: FormGroup;
  claseselecionada: any;
  tiposervicio: any;  
  editarSeleccion: any;
  conductores: any; 
  botonListarDisponible: boolean = false;
  formMarca: FormGroup;
  marcaSeleccionada: any;



  // Hacer que el calendario se cierre al hacer clic fuera del componente
  @HostListener("document:click", ["$event"])
  clickout(event: MouseEvent) {
    const calendar = document.querySelector(".ngb-datepicker");
    if (calendar && !calendar.contains(event.target as Node)) {
      // Aquí el calendario se cierra automáticamente
      // Este comportamiento está controlado por autoClose='outside'
    }
  }
  constructor(
    private marcaService: MarcaService,    
    private modalService: NgbModal,  
    private fb: FormBuilder,
   
  ) { }

  maxDate: string;
  minDate: string;

  ngOnInit() {
    const today = new Date();
    const formattedDate = today.toISOString().split("T")[0];

    this.minDate = formattedDate;
    this.maxDate = formattedDate;

    this.listarMarcas();
    const user = localStorage.getItem('usuario');
   

    this.formMarca = this.fb.group({
    id: [null],
    marca: [null],
    estado: [1],
    usuario: [user],

    });

  }



  estadoDeshabilitado = true;
  


listarMarcas(): void {
  this.marcaService.getMarcasInactivas().subscribe({
    next: (data) => {
      this.marcas = data;
      this.filteredTableItems = [...this.marcas];
    },
    error: (err) => {
      console.error("❌ Error cargando marcas:", err);
      this.marcas = [];
      this.filteredTableItems = [];
    },
  });
}
  
  private cerrarModalYRecargar() {
    this.modalService.dismissAll(); // Cierra el modal
    this.listarMarcas(); // Recarga las tarjetas para la placa actual
  }

  activarMarca(marca: string) {
    Swal.fire({
      title: "ACTIVAR",
      text: `¿Desea activar la marca: ${marca}?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#7366FF",
      cancelButtonColor: "#d33",
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        // Llamada al servicio para activar la marca
        this.marcaService.activarMarca(marca).subscribe({
          next: () => {
            Swal.fire({
              icon: "success",
              title: "¡Marca activada!",
              text: "El estado de la marca ha sido actualizado correctamente.",
              confirmButtonText: "Aceptar",
            });
  
            // Función para cerrar el modal y recargar los datos
            this.cerrarModalYRecargar();
          },
          error: (error) => {
            const mensaje =
              error?.error?.message || "No se pudo activar la marca";
            
            Swal.fire({
              icon: "error",
              title: "Error",
              text: mensaje,
              confirmButtonText: "Aceptar",
            });
  
            console.error("Error al activar marca:", error);
          },
        });
      }
    });
  }
  
  

   exportToPDF(tableId:string,nameFile:string,titleFile:string) {
    Utils.exportToPDF(tableId, nameFile,titleFile);
    }
  
  
    exportarExcel(tableId:string,nameFile:string) {
      Utils.exportVisibleTableToExcel(tableId, nameFile);
    }
  

      ngOnDestroy() {
       //  this.algunObservable.unsubscribe();
    }

filterData() {
  this.filteredTableItems = this.marcas.filter(marca =>
    marca.marca.toLowerCase().includes(this.searchText.toLowerCase())
  );
  this.page1 = 1; // Reinicia a la primera página al filtrar
}

sortData(column: string): void {
  if (this.sortColumn === column) {
    this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
  } else {
    this.sortColumn = column;
    this.sortDirection = 'asc';
  }

  this.filteredTableItems.sort((a, b) => {
    const aValue = this.getValue(a, column);
    const bValue = this.getValue(b, column);

    if (aValue == null) return 1;
    if (bValue == null) return -1;

    if (typeof aValue === 'string') {
      return this.sortDirection === 'asc'
        ? aValue.localeCompare(bValue)
        : bValue.localeCompare(aValue);
    }

    return 0;
  });
}

getValue(item: any, column: string): any {
  switch (column) {
    case 'marca': return item.marca;
    default: return '';
  }
}

 
}
